import { Card, Empty, Tabs } from 'antd';
import React from 'react';
import StatsItem from './StatsItem';

function StatsData({ stats }) {
  const items = Object.keys(stats);
  
  return (
    <Card title={<h5>Subscriber Data</h5>}>
      {
        items.length === 0 ?
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          :
          <Tabs
            large="large"
            defaultActiveKey="1"
            items={items.sort().map((item, index) => {
              const id = String(index + 1);

              return {
                label: <p className="text-uppercase">{item}</p>,
                key: id,
                children: <StatsItem data={stats[item]} />,
              };
            })}
          />
      }
    </Card>
  );
};

export default StatsData;